import { ContingencyEmissionTypeEnum } from '@/core/domain/invoice/settings/Settings.types';
import { Select, SelectProps } from 'antd';

const ContingencyIssueTypeSelect = ({ ...props }: SelectProps) => {
  const options = [
    {
      label: 'Emissão normal',
      value: ContingencyEmissionTypeEnum.NORMAL_EMISSION,
    },
    {
      label: 'Contingência SVC-AN (SEFAZ Virtual de Contingência do AN)',
      value: ContingencyEmissionTypeEnum.SVCAN,
    },
    {
      label: 'Contingência SVC-RS (SEFAZ Virtual de Contingência do RS)',
      value: ContingencyEmissionTypeEnum.SVCRS,
    },
    {
      label:
        'Contingência FS-IA (Formulário de Segurança Impressão Automática)',
      value: ContingencyEmissionTypeEnum.FSIA,
    },
    {
      label: 'Contingência FS-DA (Formulário de Segurança Documento Auxiliar)',
      value: ContingencyEmissionTypeEnum.FSDA,
    },
  ];

  return <Select options={options} allowClear {...props} />;
};

export default ContingencyIssueTypeSelect;
